import React from 'react';

import { LeftOutlined } from '@ant-design/icons';
import { Col, Drawer, Row, Select, Spin } from 'antd';

import { useProductChangeHistoryDetails } from 'v2/hooks/useProductChangeHistoryDetails';
import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import ChangesList from './ChangesList';
import { FieldsNameBR } from './constants';
import type { ChangeLogHistory } from './constants';
import { Title } from './Title';

type ChangeHistoryDetailsProps = {
  data: ChangeHistoryContentItem;
  isOpen: boolean;
  onClose: () => void;
};

function ChangeHistoryDetails({ data, isOpen, onClose }: ChangeHistoryDetailsProps) {
  const [filteredField, setFilteredField] = React.useState('0');

  const changeHistoryDetailsQuery = useProductChangeHistoryDetails({
    productId: data.productId,
    historyId: data.historyId
  });

  const handleChange = (value: string) => {
    setFilteredField(value);
  };

  const getFilterActionOptions = (changeLog: ChangeLogHistory[]) => {
    const fields = changeLog.map(history => ({
      label: FieldsNameBR[history.field as keyof typeof FieldsNameBR],
      value: history.field
    }));

    return [{ label: 'Busque por campo', value: '0' }, ...fields];
  };

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      footer={null}
      width='100vw'
      title={<Title content={data} />}
      closeIcon={<LeftOutlined />}
    >
      <Row gutter={[16, 16]} justify='center'>
        {changeHistoryDetailsQuery.isLoading && (
          <Col>
            <Spin />
          </Col>
        )}

        {changeHistoryDetailsQuery.data && (
          <>
            <Col span={24}>
              <Select
                className='w-full md:w-[40%]'
                value={filteredField}
                onChange={handleChange}
                options={getFilterActionOptions(changeHistoryDetailsQuery.data)}
              />
            </Col>

            <ChangesList changelog={changeHistoryDetailsQuery.data} filteredField={filteredField} />
          </>
        )}
      </Row>
    </Drawer>
  );
}

export default ChangeHistoryDetails;
